
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class Footer extends Vue {

  getVersion() {
    return (process.env.VUE_APP_COPYRIGHT).toUpperCase() + ' ' +  process.env.VUE_APP_VERSION_NUMBER;
  }
}
